export default __webpack_public_path__ + "static/media/IMG_5735.85fee496.JPG";